module.exports = __webpack_public_path__ + "img/TBWTTNL_fit-puzzle.9e885d95.jpg";